import Component from '@glimmer/component';
import { service } from '@ember/service';
import { modifier } from 'ember-modifier';
import { t } from 'ember-intl';
import TioLoadingSpinner from 'tio-common/components/tio/loading-spinner';
import type PreviewService from 'tio-employee/services/preview';

interface Signature {
  Args: {
    /** The hand-off query params as the route read them: `surface` (partner | employee) and `experience` (current | beta). */
    model: { surface?: unknown; experience?: unknown };
  };
}

export default class PreviewPage extends Component<Signature> {
  @service declare preview: PreviewService;

  begin = modifier(() => {
    void this.preview.start.perform(this.args.model);
  });

  get failureKey() {
    return `preview.failure.${this.preview.failure ?? 'refused'}`;
  }

  <template>
    <div class="tio-col-flush h-screen container mx-auto" data-test-preview-handoff {{this.begin}}>
      {{#if this.preview.failure}}
        <h1 class="mt-6 text-center" data-test-preview-failed>{{t "preview.failed_title"}}</h1>
        <p class="text-center tio-text-sm-normal tio-fg-muted">{{t this.failureKey}}</p>
      {{else}}
        <h1 class="mt-6 text-center">{{t "preview.starting"}}</h1>
        <div class="tio-row-flush grow">
          <TioLoadingSpinner />
        </div>
      {{/if}}
    </div>
  </template>
}
